import { useState, useRef } from "react";
import api from "@/lib/api";
import { Paperclip, X, UploadSimple } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AssetUploader({ value = [], onChange, label = "Attach files", testid = "asset-uploader" }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef();

  const handleFiles = async (files) => {
    if (!files?.length) return;
    setUploading(true);
    const out = [...value];
    for (const f of files) {
      try {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post("/files/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        out.push(data);
      } catch (e) {
        toast.error(`Failed to upload ${f.name}`);
      }
    }
    onChange?.(out);
    setUploading(false);
  };

  const remove = (id) => onChange?.(value.filter((f) => f.id !== id));

  return (
    <div data-testid={testid}>
      <div className="tech-label mb-2">{label}</div>
      <div
        className="border-2 border-dashed border-[var(--gc-navy)] hover:border-[var(--gc-orange)] transition-colors p-8 cursor-pointer text-center bg-white"
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handleFiles(Array.from(e.dataTransfer.files || [])); }}
      >
        <UploadSimple size={32} className="mx-auto text-[var(--gc-navy)]" weight="bold" />
        <div className="text-sm mt-3 text-[var(--gc-navy)] font-semibold">{uploading ? "Uploading…" : "Drop files or click to upload"}</div>
        <div className="tech-label mt-1">PDF · JPG · PNG · AI · PSD · ZIP · Any size</div>
        <input
          ref={inputRef} type="file" multiple className="hidden"
          onChange={(e) => handleFiles(Array.from(e.target.files || []))}
          data-testid={`${testid}-input`}
        />
      </div>
      {value.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid={`${testid}-list`}>
          {value.map((f) => (
            <li key={f.id} className="flex items-center justify-between bg-white border-2 border-[var(--gc-navy)] px-3 py-2 text-sm">
              <div className="flex items-center gap-2 truncate">
                <Paperclip size={16} className="text-[var(--gc-orange)]" />
                <span className="truncate font-semibold text-[var(--gc-navy)]">{f.original_filename}</span>
                <span className="tech-label ml-2">{Math.round((f.size||0)/1024)} KB</span>
              </div>
              <button onClick={() => remove(f.id)} className="text-[var(--gc-navy)] hover:text-[var(--gc-danger)]" data-testid={`remove-file-${f.id}`}>
                <X size={16} weight="bold"/>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
